<div ng-controller="GroupController as groupCtrl" class="modal-view">
    <c-auto-form config="groupCtrl.autoFormConfig"></c-auto-form>
</div>